var PubSub = require("underpub-js");
var Vimeo = require("@vimeo/player");

var modalVideo = function(options){

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

modalVideo.prototype.init = function(){

	var self = this;

	// init video player
	var playerIframe = this.options.$el.find('iframe')[0];
	this.player = new Vimeo.default(playerIframe);

	PubSub.subscribe('modalVideo:show', function(videoUrl) {

		var videoUrlSegments = videoUrl.split('/');

		var videoId = videoUrlSegments[videoUrlSegments.length - 1];

		self.player.loadVideo(videoId);

		self.showModal();
		
	});

	this.options.$el.find('.background-overlay').click(function() {
		self.hideModal();
	});

};

modalVideo.prototype.showModal = function(){

	this.options.$el.removeClass('no-longer-shown').addClass('active');

};

modalVideo.prototype.hideModal = function(){

	this.options.$el.removeClass('active').addClass('no-longer-shown');

};

module.exports = modalVideo;
